<div class="inventory-filters">
  <div class="inventory-filters-row">
    <app-select
      class="filter-custom-view"
      [placeHolder]="'tableActionsAndFilters.customViewText' | labelsProvider"
      [options]="customViewOptions"
      [useLabelProviderPipe]="true"
      (optionOnSelection)="tableCustomViewChange($event)"
      [clearSelectionObservable]="clearCustomViewSelection$"
    >
    </app-select>

    <app-search-box
      class="filters-search"
      (textOnSelection)="searchSubmitted($event)"
      [placeholder]="'inventoryPage.filters.search' | labelsProvider"
      [startingValue]="pageFilters.search.getFilterValue()"
      [newValueTriggered$]="searchBoxNewValue"
      [syncValidators]="searchValidators"
      [searchAsYouType]="true"
      [debounceTime]="300"
    >
    </app-search-box>
    <app-date-picker
      class="filters-date-picker"
      (dateOnSelection)="fromDateSelected($event)"
      label="tableActionsAndFilters.createdSinceDate"
      [startingValue]="pageFilters.fromDate.getFilterValue()"
      [newValueTriggered$]="fromDateNewValue"
      [maxDate]="pageFilters.toDate.getFilterValue()"
    >
    </app-date-picker>
    <app-date-picker
      class="filters-date-picker"
      (dateOnSelection)="toDateSelected($event)"
      label="tableActionsAndFilters.createdUntilDate"
      [startingValue]="pageFilters.toDate.getFilterValue()"
      [newValueTriggered$]="toDateNewValue"
      [minDate]="pageFilters.fromDate.getFilterValue()"
    >
    </app-date-picker>
  </div>
  <app-view-filters-multi-select [pageFilters]="pageFilters"></app-view-filters-multi-select>
</div>
